import React from 'react';

import type { Apollo as ApolloTypes } from 'src/gql/generated';

import { PhaseTaskRow } from './PhaseTaskRow';
import type { ParkedWorkflowMeta } from '../use-parked-workflow-completion';

type PhaseTask = ApolloTypes.PhaseSimple_NonSigningPhase_Fragment['tasks'][number];

interface PhaseTaskRowWithSubtasksProps {
  readOnly: boolean;
  row: { subtasks: PhaseTask[]; task: PhaseTask };
  workflow: ParkedWorkflowMeta;
  hideStatus?: boolean;
}

// A root task's row followed by its subtasks' indented rows.
export const PhaseTaskRowWithSubtasks = React.memo(function PhaseTaskRowWithSubtasks({
  hideStatus,
  readOnly,
  row,
  workflow,
}: PhaseTaskRowWithSubtasksProps) {
  return (
    <>
      <PhaseTaskRow
        hideStatus={hideStatus}
        readOnly={readOnly}
        task={row.task}
        workflow={workflow}
      />
      {row.subtasks.map(subtask => (
        <PhaseTaskRow
          key={subtask.id}
          isSubtask
          readOnly={readOnly}
          task={subtask}
          workflow={workflow}
        />
      ))}
    </>
  );
});
